import { Directive, ElementRef, HostListener, Input } from '@angular/core';

import { UtilService } from '../services/util.service';

@Directive({
  selector: '[appAllowPattern]',
})
export class AllowPatternDirective {
  @Input() appAllowPattern = '';

  private specialKeys: Array<string> = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];

  constructor(private elementRef: ElementRef, private utilService: UtilService) {}

  // ngOnInit(): void {
  // console.log(this.appAllowPattern);
  // let a = this.utilService.validatePattern(this.elementRef.nativeElement, this.appAllowPattern);
  // }

  @HostListener('keypress', ['$event']) handleKeyPress(event: KeyboardEvent) {
    const pattern = this.utilService.selectInputPattern(this.appAllowPattern);

    if (new RegExp(pattern).test(String(event.key || event.code))) {
      return true;
    }

    event.preventDefault();
    return false;
  }

  // Handle key events
  /*@HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent) {
    const pattern = this.utilService.selectInputPattern(this.appAllowPattern);

    let keyCodeChar = String(e.key);

    console.log(keyCodeChar);

    // Allow Backspace, ArrowLeft, ArrowRight, Home, End
    // if (this.specialKeys.indexOf(keyCodeChar) !== -1) return true;

    // Allow Backspace
    // if (keyCodeChar === 'Backspace') return true;

    // If the keyCode char does not match the allowed Regex Pattern, then don't allow the input into the field.
    if (!keyCodeChar.match(new RegExp(pattern, 'i'))) {
      e.preventDefault();

      return false;
    }

    return true;
  }*/

  // @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent) {
  //   let pattern = this.utilService.selectInputPattern(this.appAllowPattern);

  //   // const initalValue = this.elementRef.nativeElement.value;
  //   // this.elementRef.nativeElement.value = initalValue.replace(pattern, '');

  //   // if (initalValue !== this.elementRef.nativeElement.value) {
  //   //   // e.stopPropagation();
  //   //   e.preventDefault();

  //   //   return false;
  //   // }

  //   const initalValue = this.elementRef.nativeElement.value;
  //   this.elementRef.nativeElement.value = initalValue.replace(pattern, '');
  //   if (initalValue !== this.elementRef.nativeElement.value) {
  //     e.stopPropagation();
  //   }
  // }

  // @HostListener('keydown', ['$event'])
  // onKeyDown(event: KeyboardEvent) {
  //   // Allow Backspace, tab, end, and home keys
  //   // if (this.specialKeys.indexOf(event.key) !== -1) {
  //   //   return;
  //   // }

  //   let current: string = this.elementRef.nativeElement.value;
  //   let next: string = current.concat(event.key);
  //   if (next && !String(next).match(this.regex)) {
  //     event.preventDefault();
  //   }
  // }

  // @HostListener('mouseenter') onMouseEnter() {
  // console.log(this.appAllowPattern);

  // this.highlight(this.appAllowPattern || 'red');
  // }

  // private highlight(color: string) {
  //   this.elementRef.nativeElement.style.backgroundColor = color;
  // }

  // private name(value: string) {
  // this.elementRef.nativeElement.style.proptery = value;
  // }
}
